import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import PropTypes from 'prop-types';
import remarkBreaks from 'remark-breaks';

import Anchor from '../Anchor';

const Markdown = ({
  children,
}) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm, remarkBreaks]}
    components={{
      a: ({ node, ...linkProps }) => (
        <Anchor cellContent={linkProps.href} />
      ),
    }}
  >
    {children}
  </ReactMarkdown>
);

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Markdown;
